/**
 * ConnectorTypeCard — a single tile in the "add new connector" grid.
 * Clicking opens the config dialog pre-filled for that type.
 */

import { useTranslation } from 'react-i18next';

import type { ConnectorType } from '@/api/types';
import { ConnectorIcon } from './ConnectorIcon';

export function ConnectorTypeCard({
  type,
  onPick,
}: {
  type: ConnectorType;
  onPick: (type: ConnectorType) => void;
}) {
  const { t } = useTranslation('connectors');

  return (
    <button
      type="button"
      onClick={() => onPick(type)}
      className="group flex flex-col items-start gap-3 rounded-lg border border-border bg-surface p-5 text-start shadow-subtle transition-all hover:-translate-y-0.5 hover:border-spark hover:shadow-raised"
    >
      <span className="flex h-10 w-10 items-center justify-center rounded-md bg-spark-soft text-spark">
        <ConnectorIcon type={type} className="h-6 w-6" />
      </span>
      <div className="flex flex-col gap-0.5">
        <h3 className="text-sm font-semibold text-ink">{t(`types.${type}.name`)}</h3>
        <p className="text-xs leading-relaxed text-ink-muted">{t(`types.${type}.blurb`)}</p>
      </div>
      <span className="mt-auto text-[11px] font-medium text-spark opacity-0 transition-opacity group-hover:opacity-100">
        {t('add.pick_cta')}
      </span>
    </button>
  );
}
